<template>
  <v-card>
    <v-card-title class="h6">
      <div class="d-flex flex-column">
        Pirates Info
        <span class="caption">last update: {{ getLocaleTime(info.updatedAt) }}</span>
      </div>
      <v-spacer />
      <v-btn
        icon
        color="grey"
        @click="getData"
      >
        <v-icon>{{ mdiReload }}</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text v-if="loading" class="text-center">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      />
    </v-card-text>
    <v-card-text v-else>
      <v-simple-table dense>
        <template v-slot:default>
          <tbody>
            <tr>
              <td class="caption">Keys</td>
              <td class="caption">{{ info.keys }}</td>
            </tr>
            <tr>
              <td class="caption">Sessions</td>
              <td class="caption">{{ info.sessions }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-divider class="mt-4"></v-divider>
      <div class="d-flex justify-space-between">
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th>Store</th>
                <th class="text-left">
                  Percentage by Keys
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="info.store.length === 0">
                <td class="text-center caption" colspan="4">No data</td>
              </tr>
              <template v-else>
                <tr
                  v-for="item in info.store"
                  :key="item.name"
                >
                  <td class="caption">{{ item.name }}</td>
                  <td class="caption">{{ (item.percentage).toFixed(0) }}%</td>
                </tr>
              </template>
            </tbody>
          </template>
        </v-simple-table>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th>Locale</th>
                <th class="text-left">
                  Percentage
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="info.locale.length === 0">
                <td class="text-center caption" colspan="4">No data</td>
              </tr>
              <template v-else>
                <tr
                  v-for="item in info.locale"
                  :key="item.name"
                >
                  <td class="caption">{{ item.name }}</td>
                  <td class="caption">{{ (item.percentage).toFixed(0) }}%</td>
                </tr>
              </template>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mdiReload } from '@mdi/js';
import helper from '../../plugins/helpers/mixin-helper'
export default {
  mixins: [
    helper
  ],
  data () {
    return {
      loading: true,
      mdiReload,
      info: {
        updatedAt: 'not calculated yet',
        store: [],
        locale: []
      }
    }
  },
  watch: {
    async '$route.params' () {
      await this.getData()
    }
  },
  async mounted () {
    await this.getData()
  },
  methods: {
    async getData () {
      this.loading = true
      const { data } = await this.$axios.get(
        `${this.$store.getters.projectPath}/marketing/telemetry/global-info/pirates`, {
          params: {
            build_tag: this.$route.params.buildTag
          }
        }
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.info = data
      }
      this.loading = false
    },
    getLocaleTime (datetimeString) {
      if (datetimeString === 'not calculated yet') {
        return datetimeString
      }

      const date = new Date(datetimeString).toLocaleTimeString('uk-UA', {
        hour: '2-digit',
        minute: '2-digit'
      })

      return date
    }
  }
}
</script>

